import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class PushForwardRedovisningshanvisningGiltighetCommand extends BasicCommand<PushForwardRedovisningshanvisningGiltighetCommand> {
    inmatningshandelssortiment: string;
    arbetsorderId: number;
    mottagningsplatsnummer: string;
    typ?: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "PushForwardRedovisningshanvisningGiltighetCommand";

    get primaryKey(): IPrimaryKey<PushForwardRedovisningshanvisningGiltighetCommand> {
        return {
            inmatningshandelssortiment: this.inmatningshandelssortiment,
            arbetsorderId: this.arbetsorderId,
            mottagningsplatsnummer: this.mottagningsplatsnummer
        };
    }
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    constructor(init: (instance: PushForwardRedovisningshanvisningGiltighetCommand) => void) {
        super(PushForwardRedovisningshanvisningGiltighetCommand.$type, PushForwardRedovisningshanvisningGiltighetCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
